/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com
 */

// Styles
// import 'vuetify/styles';
import '@/styles/main.scss';

// Composables
import { createVuetify } from 'vuetify';
import { h } from 'vue'; // Import h for custom rendering

// Theme Configuration
const lightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FAFAFA',
    primary: '#006aff', // Custom primary color
    secondary: '#ff004b', // Custom secondary color
    error: '#b00020',
    info: '#2196f3',
    success: '#4caf50',
    warning: '#fb8c00',
  },
};

const darkTheme = {
  dark: true,
  colors: {
    background: '#1a1a1a',
    surface: '#2a2a2a',
    primary: '#006aff', // Custom primary color
    secondary: '#ff004b', // Custom secondary color
    error: '#cf6679',
    info: '#2196f3',
    success: '#4caf50',
    warning: '#fb8c00',
  },
};

// Sprite URLs
const spriteUrl = '/assets/svg/sprite.svg?v=7'; // Change version when change the file to avoid old cached version
const spriteUrlLine = '/assets/svg/spriteLine.svg?v=7'; // Change version when change the file to avoid old cached version

// Vuetify Instance
export default createVuetify({
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
      darkTheme,
    },
  },
  icons: {
    defaultSet: 'salon',
    aliases: {
      // Default Vuetify aliases, if needed
    },
    sets: {
      salon: {
        component: {
          props: ['icon', 'class'], // Ensure the class prop is accepted
          render(props) {
            // Directly use the icon name without removing "salon:"
            const iconName = props.icon;

            // Render the SVG from the sprite
            return h(
              'svg',
              {
                class: ['v-icon', props.class], // Include expected classes
                'aria-hidden': true,
                role: 'img',
              },
              [h('use', { 'xlink:href': `${spriteUrl}#${iconName}` })]
            );
          },
        },
      },
      salonline: {
        component: {
          props: ['icon', 'class'], // Ensure the class prop is accepted
          render(props) {
            // Directly use the icon name without removing "salonline:"
            const iconName = props.icon;

            // Render the SVG from the spriteLine
            return h(
              'svg',
              {
                class: ['v-icon', props.class], // Include expected classes
                'aria-hidden': true,
                role: 'img',
              },
              [h('use', { 'xlink:href': `${spriteUrlLine}#${iconName}` })]
            );
          },
        },
      },
    },
  },
});
